/* eslint-disable */

export const ThemeSettingsHelper = {
    checkLocalStorageForHorseBreed() {
        const horseBreed = localStorage.getItem("horseBreed")
        const bodyApp = document.querySelector("#body-app");
        if (horseBreed === "ARABIAN") {
            bodyApp.classList.add('arab-horses');
        }
        if (horseBreed === "THOROUGHBRED") {
            bodyApp.classList.remove('arab-horses');
        }
    },
}